<template>
    <div class="container-fluid m-0 p-0">
        <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
            <div class="col-sm-12 h-100 my-auto p-0 m-0">
                <span class="mx-3 font-weight-bold lead">Country List</span>
                <span class="mx-3">
                    <button class="btn btn-sm btn-outline-primary font-weight-bolder"
                            data-toggle="modal"
                            data-target="#add-country"
                    >
                        <span class="fas fa-plus"></span>
                        Add Country
                    </button>
                </span>
                <span class="float-right py-1 mx-2 pr-4">
                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                            @click="goBack"
                    >
                        <span class="fas fa-backward"></span>
                        Go Back
                    </button>
                </span>
            </div>
        </div>

        <div class="row text-small pt-3">
            <div class="col col-md-12" style="min-height: 450px !important;">

                <div class=" table-responsive text-small" style="height: 475px;">
                    <table  class="table table-hover table-bordered table-template-1 text-small sticky-header">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th class="col-name">COUNTRY CODE</th>
                            <th>COUNTRY NAME</th>
                            <th>NATIONALITY NAME</th>
                            <th>NATIONALITY CODE</th>
                            <th>STATUS</th>
                            <th class="col-actions">ACTION</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(country, index) in countryList" :key="country.id" :class="{ inactive: !country.active }">
                            <td>{{ index + pagination.from }}</td>
                            <td>{{ country.code }}</td>
                            <td>{{ country.name }}</td>
                            <td>{{ country.natl }}</td>
                            <td>{{ country.natl_code }}</td>
                            <td>{{ country.active | status }}</td>
                            <td class="text-center col-actions">
                                <button class="btn btn-sm btn-xs btn-outline-info font-weight-bolder mr-1 ml-auto"
                                        data-toggle="modal"
                                        data-target="#view-country"
                                        @click="viewCountry = country"
                                >
                                    <span class="fas fa-eye"></span>
                                    View
                                </button>
                                <button class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder mr-1 ml-auto"
                                        @click="confirmDeleteCountry(country.id)"
                                >
                                    <span class="fas fa-trash-alt"></span>
                                    Delete
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <nav aria-label="..." class="ml-3 pt-2">
                <ul class="pagination text-smallest">
                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                        <button class="page-link" @click="setPage(1)">First</button>
                    </li>

                    <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                        <button class="page-link" @click="setPage(page)">{{ page }}</button>
                    </li>

                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                        <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                    </li>
                </ul>
            </nav>

        </div>

        <view-country :view-country="viewCountry"></view-country>
        <add-country></add-country>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { paginationMixin } from "@/mixins/paginationMixin";

import ViewCountry from "@/components/sub_components/admin/countries/ViewCountry";
import AddCountry from "@/components/sub_components/admin/countries/AddCountry";

export default {
    name: "CountryIndex",

    mixins: [ vueAppMixin, paginationMixin ],

    components: { ViewCountry, AddCountry },

    data() {
        return {
            searchValue: '',
            viewCountry: {}
        }
    },

    methods: {
        ...mapActions([
            'getCountryList',
            'deleteCountry'
        ]),

        async confirmDeleteCountry(countryId) {
            if(await this.confirmDeleteAlert()) {
                let deleteCountry = await this.deleteCountry({ id: countryId });
                if(deleteCountry) {
                    this.successAlert('Country Successfully Deleted', 'DELETE');
                } else {
                    this.errorAlert('Country Failed to Delete', 'DELETE');
                }
            }
        },

        setPage(page) {
            this.pagination.currentPage = page;
            let params = { searchValue: this.searchValue, page: page };
            this.getCountryList(params);
        },

    },

    computed: {
        ...mapGetters([
            'countryList'
        ])
    },

    created() {
        let params = { searchValue: this.searchValue };
        this.getCountryList(params);
    }

}
</script>

<style scoped>

</style>